module.exports = __webpack_public_path__ + "img/icon_active.a0767d8c.svg";